import { WarehouseResult } from '@models';

export function getWarehouseDescription(warehouse: WarehouseResult): string {
  return warehouse?.Description;
}
